import { FieldHasValue } from 'helpers/Validation';

export const AsFoundResultM31Formula = (formData) => {
    if (FieldHasValue(formData.F405AftMacWasActivatedInField) && FieldHasValue(formData.F372AftHmistatus1)) {
        if (formData.F405AftMacWasActivatedInField === 'YES' && formData.F372AftHmistatus1 === 'ALARM') {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
